'use strict';

import ngResource from 'angular-resource';

function MonthlyMaxDemandPowerService ($resource) {
    return $resource(
        '/api/monthly_max_demand_power/:id', { id: '@id' },
        { 
            show : { method: 'GET', isArray: false },
            showYearly : { method: 'GET', isArray: false , params: { yearly: true } }
        }
    )
}

export default angular.module('leptonApp.MonthlyMaxDemandPowerService', ['ngResource'])
    .factory('MonthlyMaxDemandPowerService', ['$resource', MonthlyMaxDemandPowerService])
    .name



// WEBPACK FOOTER //
// ./public/dev/components/api/monthly_max_demand_power/monthly_max_demand_power.service.js